import { render, staticRenderFns } from "./ServiceFormPaymentEdit.vue?vue&type=template&id=5683bd4e&scoped=true&"
import script from "./ServiceFormPaymentEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceFormPaymentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormPaymentEdit.vue?vue&type=style&index=0&id=5683bd4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683bd4e",
  null
  
)

export default component.exports